import Vue from "vue"
import Router from "vue-router"
import store from '@/store.js'
import Home from "./views/Home.vue"
import Resources from "./views/Resources.vue"
import Tutorials from "./views/Tutorials.vue"
import Ideas from "./views/Ideas.vue"
import Tasks from "./views/Tasks.vue"
import Privacy from "./views/Privacy.vue"
import Terms from "./views/Terms.vue"
import Manipulative from "./views/Manipulative.vue"
import Account from "./views/Account.vue"
import Redeem from "./views/Redeem.vue"
import Login from "./views/Login.vue"
import Register from "./views/Register.vue"
import ResetPassword from "./views/ResetPassword.vue"
import RecoverAccount from "@/views/RecoverAccount"
import SetPassword from "@/views/SetPassword.vue"
import VerifyAccount from "./views/VerifyAccount.vue"
import NoLicense from "./views/NoLicense.vue"
import NotFound from "./views/404.vue"
import LoginGuard from "@/util/login-guard"
import ManageTeachers from "@/views/ManageTeachers"
import InviteTeachers from "@/views/InviteTeachers"
import ManageStudents from "@/views/ManageStudents"
import FirstClassTutorial from "@/views/FirstClassTutorial"
import AdminClassTutorial from "@/views/AdminClassTutorial"
import ManageAccount from "@/views/ManageAccount"
import ManageLicenses from "@/views/ManageLicenses"
import ProcessInvitation from "@/views/ProcessInvitation"
import SignupWithInvitation from "@/views/SignupWithInvitation"
import JoinWithInvitation from "@/views/JoinWithInvitation"
import JoinWithCode from "@/views/JoinWithCode"
import SignupWithJoinCode from "@/views/SignupWithJoinCode"
import RedeemSourceCode from "@/views/RedeemSourceCode"
import RedeemRedemptionCode from "@/views/RedeemRedemptionCode"

import LoadShare from "@/views/LoadShare"

Vue.use(Router)

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "root",
      component: Home,
      beforeEnter: LoginGuard
    },
    {
      path: '/privacy-policy',
      component: Privacy,
      beforeEnter: LoginGuard
    },
    {
      path: '/terms-of-use',
      component: Terms,
      beforeEnter: LoginGuard
    },
    {
      path: '/tutorials',
      component: Tutorials
    },
    {
      path: '/ideas',
      component: Ideas
    },
    {
      path: '/resources',
      component: Resources
    },
    {
      path: '/tasks',
      component: Tasks
    },
    {
      path: "/reset-password",
      component: ResetPassword
    },
    {
      path: "/recover/:code",
      component: RecoverAccount
    },
    {
      path: "/setPassword",
      component: SetPassword
    },
    {
      path: '/manipulatives',
      name: "manipulatives",
      component: Home,
      beforeEnter: LoginGuard
    },
    {
      path: '/s/:code?',
      component: LoadShare
    },
    {
      path: '/manipulatives/:manip_name/:shareCode?',
      name: 'manipulative-view',
      component: Manipulative,
      beforeEnter: LoginGuard
    },
    {
      path: '/no-license',
      component: NoLicense
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      beforeEnter: (to, from, next) => {
        const token = store.getters.token;

        if (token) {
          next({ path: '/' });
          return;
        } 

        next();
      }
    },
    {
      path: '/verify',
      component: VerifyAccount,
      beforeRouteLeave: LoginGuard
    },
    {
      path: "/account",
      name: "account",
      component: Account,
      beforeEnter: LoginGuard,
      children: [
        {
          path: 'manage-teachers',
          component: ManageTeachers,
          beforeEnter: LoginGuard
        },
        {
          path: 'invite-teachers',
          component: InviteTeachers,
          beforeEnter: LoginGuard
        },
        {
          path: 'manage-students',
          component: ManageStudents,
          beforeEnter: LoginGuard
        },
        {
          path: 'new-school-classroom',
          component: AdminClassTutorial,
          beforeEnter: LoginGuard
        },
        {
          path: 'new-classroom',
          component: FirstClassTutorial,
          beforeEnter: LoginGuard
        },
        {
          path: 'manage-account',
          component: ManageAccount,
          beforeEnter: LoginGuard
        },
        {
          path: 'manage-licenses',
          component: ManageLicenses,
          beforeEnter: LoginGuard
        }
      ]
    },
    {
      path: "/redeem",
      name: "redeem",
      component: Redeem
    },
    {
      path: "/logout",
      name: "logout",
      beforeEnter: (to, from, next) => {
        store.dispatch('logout');
        next({ path: '/login' });
      }
    },
    {
      path: "/register",
      name: "register",
      component: Register
    },
    {
      path: "/hand2mind/register",
      name: "h2mregister",
      component: Register
    },
    {
      path: "/in/:code",
      component: ProcessInvitation
    },
    {
      path: "/in/signup/:code",
      component: SignupWithInvitation
    },
    {
      path: "/in/join/:code",
      component: JoinWithInvitation
    },
    {
      path: "/in/code/join/:code",
      component: JoinWithCode
    },
    {
      path: "/in/code/signup/:code",
      component: SignupWithJoinCode
    },
    {
      path: "/in/code/source/:code",
      component: RedeemSourceCode
    },
    {
      path: "/in/code/redemption/:code",
      component: RedeemRedemptionCode
    },
    {
      path: "/404",
      component: NotFound
    },
    {
      path: "*",
      component: NotFound
    }
  ]
});
